<template>
  <nav class="navigation">
    <div class="navigation_content" :style="navigationStyle">
      <slot name="header"></slot>
      <div
        class="navigation__categories"
        :class="{ 'navigation__categories--responsive': responsive }"
      >
        <slot></slot>
      </div>
      <slot name="footer"></slot>
    </div>
    <div
      class="navigation_content"
      :class="{ hide_tree_navigation: !displayTreeNavigation }"
    >
      <div
        class="tree_navigation__categories"
        :class="{ 'navigation__categories--responsive': responsive }"
      >
        <slot name="tree_navigation"></slot>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MainNavigation",
  props: {
    /**
     * Inline styles for the first child of nav element within this component.
     * May be used to control animation. E.g. { transform: 'translateX(32px)' }
     */
    navigationStyle: {
      type: Object,
    },
    /**
     * This value merely serves as an indicator to apply modifier styling to certain elements for smaller viewports.
     * Default: false.
     */
    responsive: {
      type: Boolean,
      default: false,
    },
    displayTreeNavigation: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style_variables/style_variables.scss";
.navigation {
  display: flex;
  width: 100%;
  margin: 0px;
  padding: 0px;
  z-index: 10;
  background: $white;

  @media (max-width: 1000px) {
    height: 100%;
  }
}
.navigation_content {
  height: 100%;
  display: flex;
  flex-direction: column;

  & > * {
    flex-shrink: 0;
  }
}
.tree_navigation__categories,
.navigation__categories {
  width: $nav_width;
  max-width: 100%;
  height: 100%;
  padding-top: 24px;
  flex-shrink: 2;
  z-index: 2;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid $grey_alabaster;
  // When there is scrolling in this box show shadows.
  background: linear-gradient(white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    radial-gradient(
      farthest-side at 50% 0,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0)
    ),
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.1),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;

  /* Opera doesn't support this in the shorthand */
  background-attachment: local, local, scroll, scroll;

  &.navigation__categories--responsive {
    @media (max-width: 1000px) {
      padding-top: 0;
    }
  }
}
.tree_navigation__categories {
  padding: 10px 24px 0 0;
  min-width: 250px;
  max-width: 400px;
  width: max-content;
}
.hide_tree_navigation {
  display: none;
}
</style>
